export class EnvVariables {
  static firebase = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  };

  static apiEndpoint = process.env.REACT_APP_API_ENDPOINT;

  static appEndpoint = process.env.REACT_APP_ENDPOINT;

  static designToolEndpoint = process.env.REACT_APP_DESIGN_TOOL_ENDPOINT;

  static cdnBaseUrl = process.env.REACT_APP_CDN_BASE_URL;
}

export class LocalStorageEnums {
  static access_token = "access_token";
  static refresh_token = "refresh_token";
  static user = "user";
}
